Date.prototype.yyyymmdd = function () {
  var mm = this.getMonth() + 1;
  var dd = this.getDate();

  return [
    this.getFullYear(),
    (mm > 9 ? "" : "0") + mm,
    (dd > 9 ? "" : "0") + dd,
  ].join("");
};

function getCurrency(date) {
  var url = new URL(
    "https://bank.gov.ua/NBUStatService/v1/statdirectory/exchange?json"
  );

  if (date) {
    var currencyDate = new Date(date);
    var params = {
      date: currencyDate.yyyymmdd(),
      json: "json",
    };
    url.search = new URLSearchParams(params).toString();
  }

  fetch(url)
    .then(function (response) {
      return response.json();
    })
    .then(function (data) {
      var list = data;
      list.sort(function (a, b) {
        return a.cc.localeCompare(b.cc);
      });
      var sel = document.getElementById("currency");
      var i = 0;
      for (i; i < list.length; i++) {
        var opt = document.createElement("option");
        opt.innerHTML =
          list[i]["cc"] + " [" + list[i]["rate"] + "]" + " - " + list[i]["txt"];
        opt.value = list[i]["rate"];
        if (list[i]["cc"] == "EUR") {
          opt.selected = true;
        }
        sel.appendChild(opt);
      }
    });
}

function isNumberKey(evt) {
  var charCode = evt.which ? evt.which : event.keyCode;
  if (charCode != 46 && charCode > 31 && (charCode < 48 || charCode > 57)) {
    return false;
  } else {
    return true;
  }
}

document.addEventListener("DOMContentLoaded", function () {
  var blockExist = document.getElementsByClassName('tax-block').length > 0;
  if (blockExist) {

  getCurrency();

  var datePicker = document.getElementById("curdate");
  datePicker.addEventListener("change", function () {
    getCurrency(datePicker.value);
  });

  var el = document.getElementById("getResult");
  el.addEventListener(
    "click",
    function () {
      var sum = document.getElementById("sum").value;
      var currency;
      if (document.getElementById("mycurrency").value != "") {
        currency = document.getElementById("mycurrency").value;
      } else {
        currency = document.getElementById("currency").value;
      }
      var taxpercent = document.getElementById("taxpercent").value;
      var fullresult = sum * currency;
      var result = sum * currency - (sum * currency * taxpercent + 1474);
      var tax = sum * currency * taxpercent + 1474;
      var ep = sum * currency * taxpercent;
      var esv = 1474;
      document.getElementById("full-result").value =
        fullresult.toFixed(2) + "₴";
      document.getElementById("result").value = result.toFixed(2) + "₴";
      document.getElementById("taxes").value = tax.toFixed(2) + "₴";
      document.getElementById("esv-ep").value =
        ep.toFixed(2) + "₴" + " + " + esv.toFixed(2) + "₴";
    },
    false
  );

};
});
